import lang from 'lang'
import config from '@/config'
import request from '@/modules/base/util/request'
import settingsConfig from '@/modules/settings/config'

import { toast } from '@/modules/base/components/toast/toastConfig'

const taxOfficeUrl = `${config.resourceHost}taxoffice/bufa`
// actions
const ACTION_PREFIX = 'vatReturn/edit'

const RESET_STATE = `${ACTION_PREFIX}/RESET_STATE`
const SHOW_DRAWER = `${ACTION_PREFIX}/SHOW_DRAWER`
const HIDE_DRAWER = `${ACTION_PREFIX}/HIDE_DRAWER`
const SHOW_LOADER = `${ACTION_PREFIX}/SHOW_LOADER`
const HIDE_LOADER = `${ACTION_PREFIX}/HIDE_LOADER`
const SET_TAX_ACCOUNTANT = `${ACTION_PREFIX}/SET_TAX_ACCOUNTANT`
const SET_VAT_RETURN = `${ACTION_PREFIX}/SET_VAT_RETURN`
const SET_COMPANY_ADDRESS = `${ACTION_PREFIX}/SET_COMPANY_ADDRESS`
const SET_TAX_NUMBER = `${ACTION_PREFIX}/SET_TAX_NUMBER`
const SET_TAX_OFFICE = `${ACTION_PREFIX}/SET_TAX_OFFICE`
const SET_TAX_OFFICE_ID = `${ACTION_PREFIX}/SET_TAX_OFFICE_ID`

// reducer
const initialState = {
  isLoading: true,
  isDrawerOpen: false,
  isNew: true,
  taxNumber: '',
  taxOffice: '',
  taxOfficeId: '',
  companyAddress: {
    companyName: '',
    city: '',
    street: '',
    zipCode: '',
    countryIso: '',
    email: '',
    website: '',
    phone1: '',
    phone2: '',
    mobile: '',
    fax: '',
  },
  vatReturn: {
    year: '',
    period: '',
    label: '',
    isCorrection: false,
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case HIDE_LOADER:
      return Object.assign({}, state, {
        isLoading: false,
      })

    case SHOW_DRAWER:
      return Object.assign({}, state, {
        isDrawerOpen: true,
      })

    case HIDE_DRAWER:
      return Object.assign({}, state, {
        isDrawerOpen: false,
      })

    case SET_TAX_ACCOUNTANT:
      const { taxAccountant } = action
      return { ...state, taxAccountant }

    case SET_VAT_RETURN:
      const { vatReturn } = action
      return { ...state, vatReturn: { ...state.vatReturn, ...vatReturn } }

    case SET_COMPANY_ADDRESS:
      const { companyAddress } = action
      return { ...state, companyAddress: { ...state.companyAddress, ...companyAddress } }

    case SET_TAX_NUMBER:
      const { taxNumber } = action
      return { ...state, taxNumber }

    case SET_TAX_OFFICE:
      const { taxOffice } = action
      return { ...state, taxOffice }

    case SET_TAX_OFFICE_ID:
      const { taxOfficeId } = action
      return { ...state, taxOfficeId }

    case RESET_STATE:
      return initialState

    default:
      return state
  }
}

// action creators
export const showLoader = () => ({
  type: SHOW_LOADER,
})

export const hideLoader = () => ({
  type: HIDE_LOADER,
})

export const showDrawer = () => ({
  type: SHOW_DRAWER,
})

export const hideDrawer = () => ({
  type: HIDE_DRAWER,
})

export const setVatReturn = (vatReturn) => ({
  type: SET_VAT_RETURN,
  vatReturn,
})

export const resetState = () => ({
  type: RESET_STATE,
})

const setCompanyAddress = (companyAddress) => ({
  type: SET_COMPANY_ADDRESS,
  companyAddress,
})

const setTaxNumber = (taxNumber) => ({
  type: SET_TAX_NUMBER,
  taxNumber,
})

const setTaxOffice = (taxOffice) => ({
  type: SET_TAX_OFFICE,
  taxOffice,
})

const setTaxOfficeId = (taxOfficeId) => ({
  type: SET_TAX_OFFICE_ID,
  taxOfficeId,
})

export const fetchAccountSettingsAndTaxOffice = () => {
  return (dispatch) => {
    dispatch(showLoader())
    request(settingsConfig.account, { auth: true, isConcurrent: true })
      .then((response) => {
        const {
          body: {
            data: { companyAddress, taxNumber, taxOfficeId },
          },
        } = response

        dispatch(setCompanyAddress(companyAddress))
        dispatch(setTaxNumber(taxNumber))
        dispatch(setTaxOfficeId(taxOfficeId))
        if (taxOfficeId) return request(`${taxOfficeUrl}/${taxOfficeId}`)
      })
      .then((response) => {
        if (response && response.body.data && response.body.data.name) {
          dispatch(setTaxOffice(response.body.data.name))
        } else {
          dispatch(setTaxOffice('zu PLZ nicht gefunden'))
        }
      })
      .catch(() => {
        toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
      })
      .done(() => dispatch(hideLoader()))
  }
}
